import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class CreditOrderReportData extends ReportData<CreditOrderReportData> {
    @field creditOrderId: number;
}
